module.exports = __webpack_public_path__ + "img/yangqianguang.07b56c6d.png";